export const theme = {
    primaryDark: '#0d0c1d',
    primaryLight: '#effffa',
    primaryHover: '#343078',
    mobile: '576px',
    desktop: '900px',
}